export const defaultUser = {
    id: '666',
    name: {
        first_name: 'Testy',
        last_name: 'McTestface',
    },
    email: 'testy.mctestface@wolt.com',
    profile_picture: null,
    roles: ['user'],
    email_verified: true,
    country: 'FIN',
    permissions: [],
};
export const defaultGuestUser = {
    id: '666',
    name: {
        first_name: 'Ilva',
        last_name: 'Blevins',
    },
    email: 'ilva.blevins@google.com',
    country: 'FIN',
};
const warningMessage = ' ' +
    "It's a no-op.\n" +
    "Provide your own override of it to 'createMockAuthenticator()' if you want to test how it's called in unit tests.\n" +
    "Or, create a real authenticator with 'createAuthenticator()' using mocked auth storage and auth service if you want to test the integration with the real authenticator.";
/**
 * Creates a mocked version of the authenticator to be used in unit tests.
 * It doesn't include any logic and just implements the authenticator API.
 *
 * The mock represents the logged-in state by default.
 * Pass `user: null` to create a mock for the logged-out state.
 *
 * You can also override the default mock to e.g. test how the authenticator's methods are called:
 *
 * @example
 *
 * const loginMock = jest.fn();
 * const authenticatorMock = createMockAuthenticator({ user: null, login: loginMock });
 *
 * render(
 *   <AuthProvider authenticator={authenticatorMock}>
 *     <LogInPage />
 *   </AuthProvider>
 * );
 *
 * userEvent.click(screen.getByText('Log In'));
 * expect(loginMock).toHaveBeenCalled();
 */
export function createMockAuthenticator({ user: userSlice, ...methodOverrides } = {}) {
    const user = userSlice === null ? undefined : { ...defaultUser, ...userSlice };
    const state = user
        ? { status: 'logged-in', user }
        : { status: 'logged-out', user: undefined };
    return {
        async getAccessToken() {
            // This token just encodes a user object with an id field and has an infinite expiration time
            return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjkwMDcxOTkyNTQ3NDA5OTEsInVzZXIiOnsiaWQiOiI2NjYifSwiaWF0IjoxNjk4MTQ0NDUzfQ.B3AW8cUnL6lBqMo1ns0W8bzN8XZuexeg6W_De8mbP7k';
        },
        getState() {
            return state;
        },
        // It is considered unexpected if these mutating methods are called in unit tests without being explicitly mocked,
        // so we issue warnings to notify the developer about such cases.
        async refreshUser() {
            console.warn('Mocked version of authenticator.refreshUser() was called.' + warningMessage);
        },
        async login() {
            console.warn('Mocked version of authenticator.login() was called.' + warningMessage);
        },
        async logout() {
            console.warn('Mocked version of authenticator.logout() was called.' + warningMessage);
        },
        // Note: we don't warn when these are called because they are used in hooks,
        // and we don't want to pollute tests output since hooks aren't necessarily meant to be mocked.
        subscribe() { },
        unsubscribe() { },
        unsubscribeAll() { },
        ...methodOverrides,
    };
}
